import { cn } from '../../../shared/utils/cn'

export type SystemHealthTab = 'overview' | 'service-bus' | 'endpoints'

interface SystemHealthTabsProps {
  activeTab: SystemHealthTab
  onTabChange: (tab: SystemHealthTab) => void
}

const tabs = [
  { id: 'overview' as const, name: 'Overview' },
  { id: 'service-bus' as const, name: 'Service Bus' },
  { id: 'endpoints' as const, name: 'Endpoints' },
]

export function SystemHealthTabs({ activeTab, onTabChange }: SystemHealthTabsProps) {
  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="System Health Tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
              activeTab === tab.id
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            )}
          >
            {tab.name}
          </button>
        ))}
      </nav>
    </div>
  )
}
